<template>
    <div
        class="p-16 rounded-10 bg-color-brand-beige-50"
        :data-component="$options.name"
        :data-cy="
            position === ContactBtnPosition.CONTACT_INFO_TOP
                ? ContactBtnPosition.CONTACT_INFO_TOP
                : ContactBtnPosition.CONTACT_INFO_BOTTOM
        "
    >
        <div
            class="flex"
            :class="{
                'flex-col': position === ContactBtnPosition.CONTACT_INFO_TOP,
                'screen-m:min-w-0': position === ContactBtnPosition.CONTACT_INFO_BOTTOM,
            }"
        >
            <div
                v-if="contact.logoUrl"
                class="flex justify-center bg-white mb-24 border border-wildsand rounded-10 overflow-hidden screen-l:h-[128px] screen-xxl:h-[155px]"
                :class="{
                    'h-96 screen-m:max-h-96 max-w-96 screen-m:mb-0 mr-16 p-8 rounded items-center shrink-0':
                        position === ContactBtnPosition.CONTACT_INFO_BOTTOM,
                    'p-16': position === ContactBtnPosition.CONTACT_INFO_TOP,
                }"
            >
                <img
                    :src="contact.logoUrl"
                    class="object-contain max-h-full"
                    width="260"
                    height="147"
                    :alt="`Logo ${contact.name}`"
                />
            </div>
            <div
                v-if="contact.title || contact.name || contact.imprint"
                class="text-text-l"
                :class="{
                    'flex flex-col screen-m:max-w-none screen-m:min-w-0 screen-m:mr-24':
                        position === ContactBtnPosition.CONTACT_INFO_BOTTOM,
                    'max-w-[56%] screen-s:max-w-[60%]':
                        position === ContactBtnPosition.CONTACT_INFO_BOTTOM && contact.logoUrl,
                    'max-w-full': !contact.logoUrl,
                }"
            >
                <p
                    class="text-text-l-desktop font-bold break-words"
                    :class="{
                        'mb-4':
                            (position === ContactBtnPosition.CONTACT_INFO_TOP ||
                                position === ContactBtnPosition.CONTACT_INFO_BOTTOM) &&
                            contact.name,
                        'mb-24': position === ContactBtnPosition.CONTACT_INFO_TOP && !contact.name,
                        'mb-8': position === ContactBtnPosition.CONTACT_INFO_BOTTOM && !contact.name,
                    }"
                >
                    {{ contact.title }}
                </p>

                <p
                    v-if="contact.name"
                    class="mb-24 break-words"
                    :class="{
                        'mb-8': position === ContactBtnPosition.CONTACT_INFO_BOTTOM && contact.isCommercialExpose,
                        'screen-m:mb-0':
                            position === ContactBtnPosition.CONTACT_INFO_BOTTOM && !contact.isCommercialExpose,
                    }"
                >
                    {{ contact.name }}
                </p>
                <cs-copy-text-link
                    v-if="contact.imprint && position === ContactBtnPosition.CONTACT_INFO_BOTTOM"
                    class="mb-16 text-caption screen-m:mb-0"
                    @click="openImprintModal"
                    >Impressum</cs-copy-text-link
                >
                <ul
                    v-if="
                        position === ContactBtnPosition.CONTACT_INFO_BOTTOM &&
                        contact.displayCallOption &&
                        contact.contactNumbers
                    "
                    data-print-contact
                    class="hidden"
                >
                    <li
                        v-for="number in contact.contactNumbers"
                        :key="number.label"
                    >
                        {{ determineNumberLabel(number.label) }} {{ number.value }} <br />
                    </li>
                </ul>
            </div>
        </div>

        <ms-detail-contact-btn-group
            :class="{
                'flex-col-reverse': position === ContactBtnPosition.CONTACT_INFO_TOP,
                'items-end ml-auto': position === ContactBtnPosition.CONTACT_INFO_BOTTOM,
            }"
            :exposeeId="exposeeId"
            :contact="contact"
            :position="position"
            :componentId="componentId"
        />
        <ms-detail-modal-imprint
            v-if="contact.imprint"
            :isVisible="imprintModalIsVisible"
            :imprint="contact.imprint"
            @closeModal="closeImprintModal"
        />
    </div>
</template>
<script lang="ts" src="./MsDetailContactInfo.ts" />
